module.exports = __webpack_public_path__ + "static/media/VysokieTechnologii-light.f293a299.webp";